import {IVehicleImage, VehicleImageClient} from "./VehicleImageClient";
import {IVumFlattenedVehicle} from "../vum/VumFlattenedVehicleConverter";
import {LoggingFacade} from "@vwdfive/myvw-logging";

export class VehicleImageService {

    private static vilmaDefaultProvider = 'DEFAULT';

    constructor(private readonly vehicleImageClient: VehicleImageClient,
                private readonly loggingFacade: LoggingFacade) {
    }

    public async getVehicleImages(vehicle: IVumFlattenedVehicle): Promise<IVehicleImage[]> {
        try {
            const response = await this.vehicleImageClient.getImages(vehicle);
            if (!response.images) {
                throw new Error('No images in response from vehicle image service');
            }
            if (response.service === VehicleImageService.vilmaDefaultProvider) {
                return [];
            }
            return response.images;
        } catch (e: any) {
            this.loggingFacade.error('Could not fetch vehicle images', e);
            return [];
        }
    }
}